export const required = 'Обов\'язкове поле';
export const shouldBeNumber = 'Очікується число';
export const shouldBePositive = 'Очікується невід\'ємне число';
export const min = num => `Мінімальна к-сть символів: ${num}`;
export const max = num => `Максимальна к-сть символів: ${num}`;
